<template>
  <div class="inline">
    <input
      v-if="loggedInAccountGlobalId"
      type="hidden"
      name="_account_key"
      :value="loggedInAccountGlobalId"
    />
    <input v-if="loggedInUserLocalId" type="hidden" name="_user_key" :value="loggedInUserLocalId" />
  </div>
</template>

<script>
export default {
  props: {
    accountGlobalId: { type: String, default: '' },
    userLocalId: { type: String, default: '' },
  },
  computed: {
    loggedInAccountGlobalId() {
      return this.accountGlobalId || this.account?.globalId
    },
    loggedInUserLocalId() {
      return this.userLocalId || this.user?.id
    },
  },
}
</script>

<style scoped lang="scss"></style>
